<template>
  <el-dialog title="坐标找点" :visible.sync="showDialog" width="50%" :append-to-body="true" @close="handleClose">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="经纬度">
        <div>
          <el-row>
            <el-col :span="4" class="title">
              <span>经度：</span>
            </el-col>
            <el-col :span="20">
              <el-input v-model.number="latlng.lat" placeholder="请输入经度" type="number"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="title">
              <span>纬度：</span>
            </el-col>
            <el-col :span="20">
              <el-input v-model.number="latlng.lng" placeholder="请输入纬度" type="number"></el-input>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane label="经纬度">
        <div>
          <el-row>
            <el-col :span="4" class="title">
              <span>经度：</span>
            </el-col>
            <el-col :span="4">
              <el-input v-model.number="latlngDMS.lng.d" placeholder="请输入经度"></el-input>
            </el-col>
            <el-col :span="1" style="text-align: center;">°</el-col>
            <el-col :span="4">
              <el-input v-model.number="latlngDMS.lng.m" placeholder="请输入经度"></el-input>
            </el-col>
            <el-col :span="1" style="text-align: center;">′</el-col>
            <el-col :span="4">
              <el-input v-model.number="latlngDMS.lng.s" placeholder="请输入经度"></el-input>
            </el-col>
            <el-col :span="1" style="text-align: center;">″</el-col>

          </el-row>
          <el-row>
            <el-col :span="4" class="title">
              <span>纬度：</span>
            </el-col>
            <el-col :span="4">
              <el-input v-model.number="latlngDMS.lat.d" placeholder="请输入经度"></el-input>
            </el-col>
            <el-col :span="1" style="text-align: center;">°</el-col>
            <el-col :span="4">
              <el-input v-model.number="latlngDMS.lat.m" placeholder="请输入经度"></el-input>
            </el-col>
            <el-col :span="1" style="text-align: center;">′</el-col>
            <el-col :span="4">
              <el-input v-model.number="latlngDMS.lat.s" placeholder="请输入经度"></el-input>
            </el-col>
            <el-col :span="1" style="text-align: center;">″</el-col>

          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane label="CGCS2000">
        <div>
          <el-row>
            <el-col :span="4" class="title">
              <span>X：</span>
            </el-col>
            <el-col :span="20">
              <el-input v-model.number="xy.x" placeholder="请输入纵坐标"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="title">
              <span>Y：</span>
            </el-col>
            <el-col :span="20">
              <el-input v-model.number="xy.y" placeholder="请输入横坐标"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="title">
              分带类型
            </el-col>
            <el-radio v-model="cgcsDiviedType" label="3">3度带</el-radio>
            <el-radio v-model="cgcsDiviedType" label="6">6度带</el-radio>
          </el-row>
        </div>
      </el-tab-pane>
    </el-tabs>
    <span slot="footer" class="dialog-footer">
      <el-button @click="showDialog = false">取 消</el-button>
      <el-button type="primary" @click="submitForm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import util from '@/util/geoUtil.js'
import { map } from '@/util/mapManager.js'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
  },
  data() {

    return {
      showDialog: false,
      activeTab: '0', // 默认激活第一个页面
      latlng: {
        lat: 0,
        lng: 0,
      },
      latlngDMS: {
        lat: {
          d: 0,
          m: 0,
          s: 0
        },
        lng: {
          d: 0,
          m: 0,
          s: 0
        }
      },
      xy: {
        x: 0,
        y: 0
      },
      cgcsDiviedType: '3'
    };
  },
  watch: {
    show: function (n, o) {
      this.showDialog = n
    }
  },

  methods: {

    submitForm() {
      let ok = true
      switch (this.activeTab) {
        case '0':
          ok = util.isLatLngValid(this.latlng)
          if (ok) {
            map.panTo(this.latlng, { animate: true })
            this.showDialog = false
          } else
            this.$message.error('输入格式错误请检查！')
          break;
        case '1':
          ok = util.isLatLngDMSValid(this.latlngDMS)
          if (ok) {
            let tmp = util.convertLatLngDMStoLatLng(this.latlngDMS)
            map.panTo(tmp, { animate: true })
            this.showDialog = false
          } else
            this.$message.error('输入格式错误请检查！')
          break
        case '2':
          ok = util.isXYValid(this.xy)
          if (ok) {
            let res = util.convertCGCS2000GaussToWGS84(this.xy, this.cgcsDiviedType)
            console.log(res)
            map.panTo(res, { animate: true })
          } else
            this.$message.error('xy不合法,请输入带带号的完整坐标值')
          break
        default:
          break;
      }
      // 处理提交操作，根据当前激活的页面内输入的数据进行相应处理

    },
    handleClose() {
      // 给父元素传值，关闭对话框
      this.$emit('update:show', false)
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: center;
}

.el-row {
  height: 50px;
  line-height: 50px;
}

.title {
  text-align: right;
  padding-right: 10px;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/main/SearchDialog.vue